import { useEffect, useRef, useState } from 'react';

const INITIAL_REMAINING_TIME = 30;

const useAskAILoadingCard = () => {
  const [isActivated, setIsActivated] = useState(false);
  // eslint-disable-next-line no-undef
  const timerRef = useRef<NodeJS.Timeout | undefined>(undefined);
  const [title, setTitle] = useState('열심히 데이터를 수집 중이에요!');
  const [remainingTime, setRemainingTime] = useState(INITIAL_REMAINING_TIME);
  const isTimeOut = remainingTime <= 0;

  const activateTimer = () => {
    setIsActivated(true);
  };

  const resetLoadingCard = () => {
    setIsActivated(false);
    setTitle('열심히 데이터를 수집 중이에요!');
    setRemainingTime(INITIAL_REMAINING_TIME);
  };

  useEffect(() => {
    if (isActivated) {
      timerRef.current = setInterval(() => {
        setRemainingTime((prevTime) => {
          const newRemainingTime = prevTime - 1;

          if (newRemainingTime === 0) {
            clearInterval(timerRef.current);
          }

          if (newRemainingTime === INITIAL_REMAINING_TIME - 5)
            setTitle('핵심 내용만 쏙쏙!\n 답변을 만들고 있어요.');

          return newRemainingTime;
        });
      }, 1000);
    }
    return () => {
      clearInterval(timerRef.current);
    };
  }, [isActivated]);

  return {
    title,
    remainingTime,
    resetLoadingCard,
    isTimeOut,
    activateTimer,
  };
};

export default useAskAILoadingCard;
